module.exports = __webpack_public_path__ + "static/media/phone.b802b418.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/phone.png
// module id = 163
// module chunks = 0